module.exports = __webpack_public_path__ + "static/img/s_hairremoval.520f521.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/services/s_hairremoval.jpg
// module id = 99
// module chunks = 1